import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { PlantOperationCapacityDto } from "./plant-operation-capacity-dto";

export class ALLPlantOprationCapacityResponse extends GlobalResponseObject{
    data?:PlantOperationCapacityDto[];
     /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data 
     */
      constructor(status:boolean, intlCode:number, internalMessage:string, data?: PlantOperationCapacityDto[]){
        super(status,intlCode,internalMessage);
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }
}
